import { get } from 'lodash'

const MILESTONE_MIXIN = {
  computed: {
    content() {
      return get(this, 'data.content')
    },
    messages() {
      return get(this, 'data.messages')
    },
    dependencies() {
      return get(this, 'data.dependant_milestones')
    },
    hasContent() {
      return !((this.content && Array.isArray(this.content) && !this.content.length) || !this.content)
    },
    isCompletedOrDismissed() {
      return this.statusIsPresentIn(this.meta.status, ['completed', 'dismissed'])
    },
    config() {
      return get(this, 'data.config')
    }
  }
}
export default MILESTONE_MIXIN
